<template>
<div class="products-category-switch-outer">
    <el-dropdown trigger="click" @visible-change="dropdownVisible"
        @command="toOtherCategory" placement="bottom">
        <div class="products-category-switch-inner el-dropdown-link"
            :class="{active: isVisible}">
            <div class="products-category-name">数据产品</div>
        </div>
        <el-dropdown-menu slot="dropdown" class="products-category-dropdown">
            <el-dropdown-item v-for="item in routeOption" :command="item.routeTo"
                :class="{active: item.routeTo == $route.path}">{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</div>
</template>

<script>
export default {
    name: 'CategorySwitch',
    data() {
        return {
            isVisible: false,
            routeOption: [
                // {name: '影像数据', routeTo: 'https://www.cpeos.org.cn/dataSearch3D/#/standardProduct'},
                // {name: '影像数据', routeTo: 'https://www.cpeos.org.cn/tpeos/'},
                // {name: '影像数据', routeTo: 'https://cpeos.thxpace.com/tpeos'},
                {name: '影像数据', routeTo: window.dataManage.cpeosFixSearch},
                
                {name: '数据产品', routeTo: '/mall/data'},
                {name: '软件产品', routeTo: '/mall/software'},
                {name: '解决方案', routeTo: '/mall/solution'},
                {name: '其他产品', routeTo: '/mall/others'}
            ]
        }
    },
    methods: {
        dropdownVisible(e) {
            this.isVisible = e
        },
        toOtherCategory(path) {
            if(path.startsWith('http')) {
                window.open(path, '_blank')
            }else {
                this.$router.push({path: path})
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.products-category-switch-outer {
    position: fixed;
    top: 240px;
    left: 100px;
    width: 100px;
    height: 100px;
    padding: 5px;
    background-image: linear-gradient(180deg, #6F9FFF 0%, #205FDE 52%, #1951C1 100%);
    border-radius: 50%;
    box-shadow: 0px 7px 15px 0px rgba(37, 105, 242, .5);
    transition: .3s;
    z-index: 6;

    &:hover {
        box-shadow: 0px 7px 22px 0px rgba(#1951C1, .5);
    }

    .products-category-switch-inner {
        position: relative;
        width: 90px;
        height: 90px;
        text-align: center;
        background-image: linear-gradient(180deg, #FFFFFF, #E0EAFF);
        border-radius: 50%;
        outline: none;
        cursor: pointer;

        &::after {
            content: '';
            position: absolute;
            margin-top: 6px;
            left: 50%;
            right: 20px;
            width: 0;
            height: 0;
            border: 8px solid;
            border-top-color: #2569F2;
            border-left-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
            transform: translateX(-50%);
            transition: .2s;
        }
        &.active::after {
            transform: rotate(180deg) translateX(50%) translateY(50%);
        }

        > .products-category-name {
            padding: 0 16px;
            padding-top: 12px;
            color: #2569F2;
            font-size: 20px;
            font-weight: 700;
            user-select: none;
        }
    }
}
.products-category-dropdown {
    left: 98px !important;
    margin-top: -40px;
    padding: 0;
    padding-bottom: 3px;
    background-image: linear-gradient(180deg, #2569F2, rgba(37, 105, 242, .2));
    border-radius: 6px;
    z-index: 5 !important;

    > li {
        margin: 0 3px;
        background-color: white;
        color: black;
        font-weight: 700;

        &.active {
            background-color: #ecf5ff;
            color: #66b1ff;
        }
        &:first-child {
            padding-top: 50px;
        }
    }
}
</style>